// utils/costCalculations.js
import { TOKEN_USAGE_CONFIG } from '../config/constants';

/**
 * Calculate percentage of cost limit used.
 * costLimit must be supplied by the caller (sourced from the API's overview.costLimit).
 */
export const calculatePercentageUsed = (currentCost, costLimit) => {
  if (!currentCost || currentCost === 0) return 0;
  if (!costLimit || costLimit === 0) return 0;
  const percentage = (currentCost / costLimit) * 100;
  return Math.round(percentage * 100) / 100; // Round to 2 decimals
};

/**
 * Determine status based on percentage used
 */
export const getStatus = (percentageUsed) => {
  if (percentageUsed >= TOKEN_USAGE_CONFIG.CRITICAL_THRESHOLD) {
    return 'CRITICAL';
  } else if (percentageUsed >= TOKEN_USAGE_CONFIG.WARNING_THRESHOLD) {
    return 'WARNING';
  }
  return 'OK';
};

/**
 * Get status color
 */
export const getStatusColor = (status) => {
  return TOKEN_USAGE_CONFIG.STATUS_COLORS[status] || TOKEN_USAGE_CONFIG.STATUS_COLORS.OK;
};

/**
 * Format cost as currency
 */
export const formatCost = (cost) => {
  if (cost === null || cost === undefined) return '$0.00';
  return `$${Number(cost).toFixed(2)}`;
};

/**
 * Calculate average cost per request
 */
export const calculateAverageCostPerRequest = (totalCost, totalRequests) => {
  if (!totalRequests || totalRequests === 0) return 0;
  return Math.round((totalCost / totalRequests) * 100) / 100;
};

/**
 * Calculate projected monthly cost based on current burn rate
 */
export const calculateProjectedMonthlyCost = (currentCost, daysElapsed) => {
  if (!daysElapsed || daysElapsed === 0) return 0;
  const dailyAverage = currentCost / daysElapsed;
  return Math.round(dailyAverage * 30 * 100) / 100;
};

/**
 * Format large numbers with commas
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  return num.toLocaleString('en-US');
};

/**
 * Round to 2 decimal places
 */
export const roundToTwo = (num) => {
  return Math.round(num * 100) / 100;
};